"use client";

import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/layout/app-sidebar";
import { AppHeader } from "@/components/layout/app-header";
import { AuthGuard } from "@/components/layout/auth-guard";

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  return (
    <AuthGuard>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="overflow-hidden">
          <AppHeader />
          <main className="flex-1 min-h-0 overflow-hidden">{children}</main>
        </SidebarInset>
      </SidebarProvider>
    </AuthGuard>
  );
}
